import { render, staticRenderFns } from "./FPotensIKawasanKepemilikan.vue?vue&type=template&id=77a248c8&scoped=true"
import script from "./FPotensIKawasanKepemilikan.vue?vue&type=script&lang=js"
export * from "./FPotensIKawasanKepemilikan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a248c8",
  null
  
)

export default component.exports